import { createSlice } from "@reduxjs/toolkit";

const initialCmsState = {
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: null,
    cmsDetails: undefined,
    lastError: null,
};

export const callTypes = {
    list: "list",
    action: "action",
};

export const cmsSlice = createSlice({
    name: "cms",
    initialState: initialCmsState,
    reducers: {
        catchError: (state, action) => {
            state.error = `${action.type}: ${action.payload.error}`;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.error = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },
        endCall: (state, action) => {
            state.error = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        //getCmsDetails
        cmsDetailsFetched: (state, action) => {
            const { cmsDetails,type } = action.payload;
            state.actionsLoading = false;
            state[type] = cmsDetails;
            state.error = null;
        },
        // updateCms
        cmsUpdated: (state, action) => {
            state.error = null;
            state.actionsLoading = false;
            // state.cmsDetails = action.payload.cms;
        },
        // deleteCms
        cmsDeleted: (state, action) => {
            state.error = null;
            state.actionsLoading = false;
            state.entities = state.entities.filter(
                (el) => el._id !== action.payload.cms_id
            );
        },
        // remove cms details
        remmoveCmsDetails: (state, action) => {
            const { type } = action.payload;
            state.error = null;
            state.actionsLoading = false;
            state[type] = undefined;
            state.error = null;
        },
    },
});
